// import { baseApi } from "./baseApi";

// export const authApi = baseApi.injectEndpoints({
//   endpoints: (builder) => ({
//     registerUser: builder.mutation({
//       query: (body) => ({
//         url: "/Auth/register",
//         method: "POST",
//         body,
//       }),
//     }),

//     verifyOtp: builder.mutation({
//       query: (payload) => ({
//         url: "/Auth/verify-otp",
//         method: "POST",
//         body: payload,
//       }),
//     }),

//     resendOtp: builder.mutation({
//       query: (email) => ({
//         url: "/Auth/resend-otp",
//         method: "POST",
//         body: { email },
//       }),
//     }),

//     forgotPassword: builder.mutation({
//       query: (email) => ({
//         url: "/auth/forgot-password",
//         method: "POST",
//         body: { email },
//       }),
//     }),

//     resetPassword: builder.mutation({
//       query: ({ email, token, newPassword }) => ({
//         url: "/auth/reset-password",
//         method: "POST",
//         body: { email, token, newPassword },
//       }),
//     }),

//     loginUser: builder.mutation({
//       query: (credentials) => ({
//         url: "/Auth/login",
//         method: "POST",
//         body: credentials,
//       }),
//     }),

//     logoutUser: builder.mutation({
//       query: () => ({
//         url: "/Auth/logout",
//         method: "POST",
//       }),
//     }),

//     completeProfile: builder.mutation({
//       query: (formData) => ({
//         url: "/Auth/complete-profile",
//         method: "POST",
//         body: formData,
//       }),
//       invalidatesTags: ["Profile"],
//     }),

//     // ── New endpoints ──────────────────────────────────────────────────────

//     changePassword: builder.mutation({
//       query: (body) => ({
//         url: "/Auth/change-password",
//         method: "POST",
//         body,
//         // body shape: { currentPassword, newPassword, confirmNewPassword }
//       }),
//     }),

//     deactivateAccount: builder.mutation({
//       query: (body) => ({
//         url: "/Auth/deactivate-account",
//         method: "POST",
//         body,
//         // body shape: { password }
//       }),
//     }),

//     deleteAccount: builder.mutation({
//       query: (body) => ({
//         url: "/Auth/delete-account",
//         method: "DELETE",
//         body,
//         // body shape: { password, confirmText }
//       }),
//     }),

//     // ── Reactivate ─────────────────────────────────────────────────────────
//     // Called from Login when backend returns canReactivate: true in the 401.
//     // Body: { email, password }
//     // Backend: POST /Auth/reactivate-account → { token, email, id, message }
//     reactivateAccount: builder.mutation({
//       query: (body) => ({
//         url: "/Auth/reactivate-account",
//         method: "POST",
//         body,
//       }),
//     }),
//   }),
// });

// export const {
//   useRegisterUserMutation,
//   useVerifyOtpMutation,
//   useResendOtpMutation,
//   useForgotPasswordMutation,
//   useResetPasswordMutation,
//   useLoginUserMutation,
//   useCompleteProfileMutation,
//   useLogoutUserMutation,
//   useChangePasswordMutation,
//   useDeactivateAccountMutation,
//   useDeleteAccountMutation,
//   useReactivateAccountMutation,
// } = authApi;


import { baseApi } from "./baseApi";

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    registerUser: builder.mutation({
      query: (body) => ({
        url: "/Auth/register",
        method: "POST",
        body,
      }),
    }),

    verifyOtp: builder.mutation({
      query: (payload) => ({
        url: "/Auth/verify-otp",
        method: "POST",
        body: payload,
      }),
    }),

    resendOtp: builder.mutation({
      query: (email) => ({
        url: "/Auth/resend-otp",
        method: "POST",
        body: { email },
      }),
    }),

    forgotPassword: builder.mutation({
      query: (email) => ({
        url: "/auth/forgot-password",
        method: "POST",
        body: { email },
      }),
    }),

    resetPassword: builder.mutation({
      query: ({ email, token, newPassword }) => ({
        url: "/auth/reset-password",
        method: "POST",
        body: { email, token, newPassword },
      }),
    }),

    loginUser: builder.mutation({
      query: (credentials) => ({
        url: "/Auth/login",
        method: "POST",
        body: credentials,
      }),
    }),

    logoutUser: builder.mutation({
      query: () => ({
        url: "/Auth/logout",
        method: "POST",
      }),
    }),

    completeProfile: builder.mutation({
      query: (formData) => ({
        url: "/Auth/complete-profile",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Profile"],
    }),

    // ── New endpoints ──────────────────────────────────────────────────────

    changePassword: builder.mutation({
      query: (body) => ({
        url: "/Auth/change-password",
        method: "POST",
        body,
        // body shape: { currentPassword, newPassword, confirmNewPassword }
      }),
    }),

    deactivateAccount: builder.mutation({
      query: (body) => ({
        url: "/Auth/deactivate-account",
        method: "POST",
        body,
        // body shape: { password }
      }),
    }),

    deleteAccount: builder.mutation({
      query: (body) => ({
        url: "/Auth/delete-account",
        method: "DELETE",
        body,
        // body shape: { password, confirmText }
      }),
    }),

    // ── Reactivate ─────────────────────────────────────────────────────────
    // Called from Login when backend returns canReactivate: true in the 401.
    // Body: { email, password }
    // Backend: POST /Auth/reactivate-account → { token, email, id, message }
    reactivateAccount: builder.mutation({
      query: (body) => ({
        url: "/Auth/reactivate-account",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useRegisterUserMutation,
  useVerifyOtpMutation,
  useResendOtpMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useLoginUserMutation,
  useCompleteProfileMutation,
  useLogoutUserMutation,
  useChangePasswordMutation,
  useDeactivateAccountMutation,
  useDeleteAccountMutation,
  useReactivateAccountMutation,
} = authApi;